import './App.scss'
import {Routes, Route} from 'react-router-dom'
import Layout from './components/Layout'
import Home from './components/Home'
import Experience from './components/Experience'
import Projects from './components/Projects'
import About from './components/About'

function App(){
    return (
        <>
            <Routes>
                <Route path="/" element={<Layout />}>
                <Route index element={<Home />}/>
                <Route path='/experience' element={<Experience />}/>
                <Route path='/projects' element={<Projects />}/>
                <Route path='/about' element={<About />}/>
                </Route>
            </Routes>
        </>
    )
}

export default App